import { render, staticRenderFns } from "./DrugData.vue?vue&type=template&id=4cabf92d&scoped=true"
import script from "./DrugData.vue?vue&type=script&lang=js"
export * from "./DrugData.vue?vue&type=script&lang=js"
import style0 from "./DrugData.vue?vue&type=style&index=0&id=4cabf92d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cabf92d",
  null
  
)

export default component.exports